module.exports = __webpack_public_path__ + "img/full_garbage_can.6143921c.svg";